module.exports = __webpack_public_path__ + "img/main.0cee5268.png";